import { useTranslation } from 'react-i18next';

import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import { useGlobal } from '~/hooks/useGlobal';
import type { BreadcrumbsItem } from '~/stores/CatalogStore';

import MobileHeaderLayout from '../../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../../Main/MobileHeader/MobileHeaderTitle';

import tp from '../textPage.module.scss';
import styles from './DeliveryPage.module.scss';

const content = {
  ru: {
    timingTitle: 'Сроки доставки',
    timingStandard: 'Стандартная доставка: 12-16 дней',
    timingExpress: 'Ускоренная доставка: 7-10 дней',
    costTitle: 'Стоимость доставки',
    costFree: 'Бесплатная доставка при заказе от 10 000 ₽',
    costPaid: 'До 10 000 ₽ — 500 ₽',
    methodsTitle: 'Способы получения',
    methods: [
      'Доставка курьером до двери',
      'Самовывоз из пункта выдачи',
      'Доставка в постамат',
    ],
    trackingTitle: 'Отслеживание заказа',
    trackingText:
      'После отправки вы получите трек-номер для отслеживания посылки на всех этапах доставки.',
    missingTitle: 'Что делать, если посылка не пришла?',
    missingText:
      'Свяжитесь со службой поддержки — мы поможем отследить посылку и решить любые вопросы с доставкой.',
  },
  en: {
    timingTitle: 'Delivery Times',
    timingStandard: 'Standard delivery: 12–16 days',
    timingExpress: 'Express delivery: 7–10 days',
    costTitle: 'Delivery Cost',
    costFree: 'Free delivery for orders over 700 AED',
    costPaid: 'Under 700 AED — 50 AED',
    methodsTitle: 'Delivery Methods',
    methods: [
      'Courier delivery to your door',
      'Pick-up from a collection point',
      'Parcel locker delivery',
    ],
    trackingTitle: 'Order Tracking',
    trackingText:
      'Once your order is shipped, you will receive a tracking number to monitor your package at every stage of delivery.',
    missingTitle: "What if my package hasn't arrived?",
    missingText:
      'Contact our support team — we will help track your package and resolve any delivery issues.',
  },
};

const DeliveryPage = () => {
  const { t, i18n } = useTranslation();
  const { isTablet } = useGlobal();

  const lang = i18n.language.startsWith('ru') ? 'ru' : 'en';
  const c = content[lang];

  return (
    <>
      <MobileHeaderLayout
        content={<MobileHeaderTitle text={t('delivery')} />}
      />
      <div className="content-layout">
        <div className={tp.root}>
          {!isTablet && (
            <Breadcrumbs
              items={
                [
                  { text: t('home'), link: '/' },
                  { text: t('delivery'), link: '/delivery' },
                ].filter(Boolean) as BreadcrumbsItem[]
              }
            />
          )}

          <div className={tp.content}>
            <h1 className={tp.title}>{t('delivery')}</h1>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.timingTitle}</h2>
              <p className={tp.text}>{c.timingStandard}</p>
              <p className={tp.text}>{c.timingExpress}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.costTitle}</h2>
              <p className={tp.text}>{c.costFree}</p>
              <p className={tp.text}>{c.costPaid}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.methodsTitle}</h2>
              <ul className={styles.list}>
                {c.methods.map((method) => (
                  <li key={method} className={styles.listItem}>
                    {method}
                  </li>
                ))}
              </ul>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.trackingTitle}</h2>
              <p className={tp.text}>{c.trackingText}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.missingTitle}</h2>
              <p className={tp.text}>{c.missingText}</p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeliveryPage;
